export default __webpack_public_path__ + "static/media/ico-sq-16-peace.43be5368.svg";